export default __webpack_public_path__ + "static/media/list-alt-regular.12f41246.svg";